import {
  REQUEST_CUSTOMERFEEDBACKSTATISTICS,
  REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE,
  CustomerFeedbackStatisticsActions
} from "./types";
import { CustomerFeedbackStatistics } from "../../../models/Statistics";
import * as StatisticsApi from "../../../api/statisticsApi";
import { isOk } from "../../../result";

function fetchCustomerFeedbackStatistics(): CustomerFeedbackStatisticsActions {
  return {
    type: REQUEST_CUSTOMERFEEDBACKSTATISTICS,
    payload: []
  };
}

function fetchCustomerFeedbackStatisticsDone(
  CustomerFeedbackStatistics: ReadonlyArray<CustomerFeedbackStatistics>
): CustomerFeedbackStatisticsActions {
  return {
    type: REQUEST_CUSTOMERFEEDBACKSTATISTICS_DONE,
    payload: CustomerFeedbackStatistics
  };
}

/* Thunks goes here */
export const thunkFetchCustomerFeedbackStatistics = (
  periodFrom: Date,
  periodTo: Date
) => async (dispatch: any) => {
  try {
    dispatch(fetchCustomerFeedbackStatistics());
    const result = await StatisticsApi.getCustomerFeedback(
      periodFrom,
      periodTo
    );

    if (isOk(result)) {
      dispatch(fetchCustomerFeedbackStatisticsDone(result.value));
    } else {
      console.log(result.details);
      dispatch(fetchCustomerFeedbackStatisticsDone([]));
    }
  } catch (error) {
    console.log(error);
  }
};
